import * as React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { getLanguageFromLocale } from '../../Intl/utils';
import { getVocabulary } from '../util';
import getLogger, { Logger } from '../../log';

const logger: Logger = getLogger('Vocabulary/Vocabulary');

interface Props {
  v: string; // vocabulary
  l?: string; // language
  p?: string; // partition
  sort?: boolean; // Sort alphabetically
  children?: (notations: Map<string, string>) => React.ReactNode; // optional render function
}

export const Vocabulary = (props: Props): any => {
  const l: string = props.l ? props.l : null;
  const p: string = props.p ? props.p : '*';
  const sort: boolean = props.sort ? props.sort : false;
  const intl: IntlShape = useIntl();
  const v: string = props.v;
  const children = props.children;
  const lang: string = !!l ? l : getLanguageFromLocale(intl.locale);

  try {
    const notations: Map<string, string> = getVocabulary(
      !!v ? v.toLowerCase() : v,
      !!lang ? lang.toLowerCase() : lang,
      !!p ? p.toLowerCase() : p,
    );
    if (sort) {
      return children(
        new Map<string, string>(
          [...notations].sort(([k1, v1]: [string, string], [k2, v2]: [string, string]): 0 | 1 | -1 => {
            if (v1.toLowerCase() > v2.toLowerCase()) return 1;
            if (v2.toLowerCase() > v1.toLowerCase()) return -1;
            return 0;
          }),
        ),
      );
    }
    return children(notations);
  } catch (e) {
    logger.warn('Lookup failed', e);
    throw e;
  }
};
